module.exports = __webpack_public_path__ + "static/media/Honchkrow_gaussian2.9e2c51a1.png";